import { BankAccountApprovalStatus, BankAccountVerificationStatus } from 'api/employeeBankAccount';

export const bankAccountApprovalStatus: Record<
  NonNullable<BankAccountApprovalStatus>,
  NonNullable<BankAccountApprovalStatus>
> = {
  pending: 'pending',
  auto_approved: 'auto_approved',
  approved: 'approved',
  rejected: 'rejected',
};

export const bankAccountVerificationStatus: Record<
  NonNullable<BankAccountVerificationStatus>,
  NonNullable<BankAccountVerificationStatus>
> = {
  mismatch: 'mismatch',
  failed: 'failed',
  created: 'created',
  verified: 'verified',
  invalid: 'invalid',
};

export const bankAccountProofType = {
  cheque: 'cheque',
  bank_statement: 'bank_statement',
} as const;

export const bankProofTypeToLabel = {
  [bankAccountProofType.cheque]: 'Cancelled Cheque',
  [bankAccountProofType.bank_statement]: 'Bank Statement',
} as const;

export const bankFormDataInitialState = {
  bankProofType: bankAccountProofType.cheque,
  accountNumber: undefined,
  confirmAccountNumber: undefined,
  ifscCode: undefined,
}